import {applyRoleFilter, focusRole, openRolesSection} from './adapter';
import {
	openRoleCreateModal,
	openRoleDeleteModal,
	openRoleEditModal,
} from './modal';
import {resolveRoles} from './resolver';
import {readRoleCategoryCounts} from './statistics';

/**
 * Canvas permission roles.
 *
 * Named user_role rather than role: resource terms are reserved, and a bare
 * "role" would stop the Access Point and Site setting of that name being
 * found. The section on screen is still called Roles.
 *
 * Roles have no suspend and no status filter, which is why this declares
 * fewer operations than the user plugin rather than the same set.
 */
const userRolePlugin = {
	id: 'user_role',
	version: 1,
	commandVersion: 1,
	resource: 'user_role',
	operations: ['options', 'list', 'search', 'open', 'create', 'edit', 'delete', 'stats'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['settings.dashboard'],
	},
	sections: {
		'settings.roles': openRolesSection,
	},
	resolvers: {
		role: resolveRoles,
	},
	filters: {
		role: (command) => applyRoleFilter(command.params?.query),
	},
	focusHandlers: {
		role: (command) => focusRole(command.params?.entity_id),
	},
	modals: {
		'user_role.create': openRoleCreateModal,
		'user_role.edit': openRoleEditModal,
		'user_role.delete': openRoleDeleteModal,
	},
	statistics: {
		role_category_counts: readRoleCategoryCounts,
	},
};

export default userRolePlugin;
